import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { PostAuthGuard, PreAuthGuard } from './shared/guards/guards';

import { routeConstant } from './utils/constant/route.constant';

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled', // or 'top' to always scroll to top
  anchorScrolling: 'enabled',
  scrollOffset: [0, 0] // [x, y] offset when scrolling to anchors
};

const routes: Routes = [
  { path: '', redirectTo: routeConstant.pre_auth, pathMatch: 'full' },
  {
    path: routeConstant.pre_auth,
    pathMatch: 'prefix',
    canActivate: [PreAuthGuard],
    loadChildren: () =>
      import('./pre-auth/pre-auth.module').then((m) => m.PreAuthModule),
  },
  {
    path: routeConstant.post_auth,
    canActivate: [PostAuthGuard],
    pathMatch: 'prefix',
    loadChildren: () =>
      import('./post-auth/post-auth.module').then((m) => m.PostAuthModule),
  },
  { path: '**', redirectTo: routeConstant.pre_auth, pathMatch: 'prefix' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
